import React from 'react'
import { Row } from 'antd'
import { useTranslation } from 'next-i18next'
import { CustomCol, FormLabels } from 'src/components'
import { billingDataSections } from './billing-data.sections'
import { useAppDispatch, useAppSelector, useWindowSize } from 'src/app/hooks'
import PropertyOfClimatetrade from './PropertyOfClimatetrade/PropertyOfClimatetrade'
import { userAuthenticatedState, billingDataSelector, countryListSelector } from 'src/features'

const ProjectFormConfiguration: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const user = useAppSelector(userAuthenticatedState)
  const countryList = useAppSelector(countryListSelector)
  const billingData = useAppSelector(billingDataSelector)
  const sections = billingDataSections(t, dispatch, billingData, countryList)
  const { width } = useWindowSize()
  const isMobile = width < 800

  return (
    <>
      {user.is_superuser && <PropertyOfClimatetrade />}
      {sections.map((section, idx) => (
        <Row key={idx} className={isMobile && 'mt-3'}>
          <CustomCol>
            <FormLabels {...section.labels} />
          </CustomCol>

          <CustomCol>
            {section.form.children ? (
              <section.form.component {...section.form.props}>
                {section.form.children}
              </section.form.component>
            ) : <section.form.component {...section.form.props} />}
          </CustomCol>
        </Row>
      ))}
    </>
  )
}

export default ProjectFormConfiguration
